class GPSProviderTelematicProfileCollection extends App.Collections.BaseCollection {
  url = 'GPSProviderTelematicProfile';
  model = App.Models.GPSProviderTelematicProfile;
}

App.Collections.GPSProviderTelematicProfiles = GPSProviderTelematicProfileCollection;
